import React from 'react';
import { reduxForm, change } from 'redux-form';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { UserFormView } from './user-form-view';
import { validate } from '../../utils';
import { FORM_NAME, DRIVER_ROLE_NUMBER } from '../../constants';
import {
	getFormInitialValuesSelector,
	getIsAvailableUsersRolesSelector,
	getLegalsSelector,
	getIsLegalsLoadingSelector,
	getIsDriverSelector,
	getIsOptionsListLoadingSelector,
	getIsUserInfoLoadingSelector,
	getIsUsersListLoadingSelector,
	getOptionsListSelector,
	getStatusToggleFormSelector,
	getUsersListSelector,
} from '../../selectors';
import { getLocalStorageItem } from '../../../../utils/localStorage';

const UserFormWrapper = ({
	optionsList,
	isOptionsListLoading,
	isUserInfoLoading,
	legals,
	isLegalsLoading,
	isDriver,
	usersList,
	isUsersListLoading,
	isDisabled,
	onChangeField,
	isAvailableUsersRoles,
}) => {
	const history = useHistory();

	const handleCheckboxChange = field => {
		if (field === 'is_notify') {
			onChangeField(FORM_NAME, 'is_notify_todo', null);
		}
		onChangeField(FORM_NAME, 'is_notify_todo_company', null);
	};

	const handleAddUserRoleButtonClick = () => {
		history.push('?modal=user_role&mode=add');
	};

	const handleRoleChange = value => {
		const companyId = value === DRIVER_ROLE_NUMBER ? getLocalStorageItem('user_data').companyId : null;

		onChangeField(FORM_NAME, 'legal_id', companyId);
	};

	return (
		<UserFormView
			optionsList={optionsList}
			isOptionsListLoading={isOptionsListLoading}
			onAddUserRoleButtonClick={handleAddUserRoleButtonClick}
			isUserInfoLoading={isUserInfoLoading}
			legals={legals}
			isLegalsLoading={isLegalsLoading}
			isDriver={isDriver}
			usersList={usersList}
			isUsersListLoading={isUsersListLoading}
			isDisabled={isDisabled}
			onCheckboxChange={handleCheckboxChange}
			isAvailableUsersRoles={isAvailableUsersRoles}
			onRoleChange={handleRoleChange}
		/>
	);
};

const withForm = reduxForm({
	form: FORM_NAME,
	enableReinitialize: true,
	onSubmit: validate,
	keepDirtyOnReinitialize: true,
})(UserFormWrapper);

const mapStateToProps = createStructuredSelector({
	optionsList: getOptionsListSelector(),
	isOptionsListLoading: getIsOptionsListLoadingSelector(),
	isUserInfoLoading: getIsUserInfoLoadingSelector(),
	legals: getLegalsSelector(),
	isLegalsLoading: getIsLegalsLoadingSelector(),
	isDriver: getIsDriverSelector(),
	usersList: getUsersListSelector(),
	isUsersListLoading: getIsUsersListLoadingSelector(),
	isDisabled: getStatusToggleFormSelector(),
	initialValues: getFormInitialValuesSelector(),
	isAvailableUsersRoles: getIsAvailableUsersRolesSelector(),
});

const mapDispatchToProps = {
	onChangeField: change,
};

const UserForm = connect(mapStateToProps, mapDispatchToProps)(withForm);

UserFormWrapper.propTypes = {
	optionsList: PropTypes.objectOf(
		PropTypes.arrayOf(
			PropTypes.shape({
				text: PropTypes.string.isRequired,
				value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
				key: PropTypes.string.isRequired,
			}),
		),
	),
	isOptionsListLoading: PropTypes.objectOf(PropTypes.bool.isRequired).isRequired,
	isUserInfoLoading: PropTypes.bool.isRequired,
	legals: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string.isRequired,
		}),
	).isRequired,
	isLegalsLoading: PropTypes.bool.isRequired,
	isDriver: PropTypes.bool.isRequired,
	usersList: PropTypes.arrayOf(
		PropTypes.shape({
			text: PropTypes.string.isRequired,
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
		}),
	).isRequired,
	isUsersListLoading: PropTypes.bool.isRequired,
	isDisabled: PropTypes.objectOf(PropTypes.bool).isRequired,
	onChangeField: PropTypes.func.isRequired,
	isAvailableUsersRoles: PropTypes.bool.isRequired,
};

export { UserForm };
